import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { Select2 } from "select2-react-component";
import NumberFormat from 'react-number-format';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, Badge } from "reactstrap";

export default class Stuff extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'allservicestuff',
            id: props.Id,
            data2: null,
            data: null,
            loading: true,
            page: 1,
            per_page: 10,
            phrase: ''
        };
    }
    toggle = () => this.setState({ modal: !this.state.modal });
    componentDidMount() {
        this.httpPost("api/v1/stuff/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data2: data,
                        loading: false
                    })
                    this.refreshData();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setkala(id, title,tax) {
        this.state.data2.record.name = title;
        this.state.data2.record.taxNumber = id.toString();
        this.state.data2.record.taxRate = parseInt(tax);
        this.setState({
            data2: this.state.data2,
            modal: !this.state.modal
        });
    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/stuff/save", {
            id: this.getCurrentFormId(),
            companyId: this.state.data2.global.company.id,
            name: this.state.data2.record.name,
            unitId: this.state.data2.record.unitId,
            taxNumber: this.state.data2.record.taxNumber,
            price: parseInt(this.state.data2.record.price),
            taxRate: parseInt(this.state.data2.record.taxRate),
            wage: parseInt(this.state.data2.record.wage),
            rightOfAction: parseInt(this.state.data2.record.rightOfAction),
            profit: parseInt(this.state.data2.record.profit),
            discountPercent: parseInt(this.state.data2.record.discountPercent),
            status: this.state.data2.record.status,

        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/stuffs'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.setState({

                modal: !this.state.modal,

            })
        }
    }
    inquery(e) {
        this.httpPost("api/v1/common/getestuffcode", {
            companyId: this.state.data2.global.company.id,
            code: this.state.data2.record.taxNumber
        })
            .then(data2 => {
                if (data2.status === -1) window.location.href = "/login";
                if (data2.status === 1) {
                    this.showSuccessMessage("استعلام انجام پذیرفت");
                    this.state.data2.record.name = data2.record.vat;
                    this.state.data2.record.taxRate = data2.record.descriptionOfID;
                    this.setState({
                        loading: false,
                    })
                }
                else {
                    this.showErorrMessage(data2.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    changeStatus(checked) {
        this.state.data2.record.status = checked;
        this.setState({ data2: this.state.data2 });
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block-head nk-block-head-lg wide-sm">
                                <div className="nk-block-head-content">
                                    <div className="nk-block-head-sub">
                                        <a className="back-to" to="/stuffs/"><em className="icon ni ni-arrow-left"></em><span>فهرست کالاها/خدمات</span></a>
                                    </div>
                                </div>
                            </div>
                            <div className="nk-block nk-block-lg">
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="card-head">
                                            <h5 className="card-title">اطلاعات کالا / خدمت</h5>
                                        </div>
                                        <br />
                                        <form method="post" onSubmit={e => this.save(e)} className="row g-4">

                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <div className="custom-control custom-switch">
                                                            <input type="checkbox" className="custom-control-input" id="customSwitch2" onChange={e => this.changeStatus(e.target.checked)} defaultChecked={this.state.data2.record.status} />
                                                            <label className="custom-control-label" htmlFor="customSwitch2"> کالای مربوط به طلا جواهر </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <br />
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">شرح کالا/خدمت</label>
                                                        <div className="form-control-wrap">
                                                            <input className="form-control" onKeyPress={this.handleKeyPress} type="text" defaultValue={this.state.data2.record.name} onChange={e => this.state.data2.record.name = e.target.value} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">شناسه کالا/خدمت</label>
                                                        <div className="form-control-wrap">
                                                            <input className="form-control" onKeyPress={this.handleKeyPress} type="text" defaultValue={this.state.data2.record.taxNumber} onChange={e => this.state.data2.record.taxNumber = e.target.value} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">واحد اندازه گیری</label>
                                                        <div className="form-control-wrap">

                                                            <select className="form-control" type="text" defaultValue={this.state.data2.record.unitId} onChange={e => this.state.data2.record.unitId = parseInt(e.target.value)}>
                                                                <option value='0'>انتخاب نمایید...</option>
                                                                {this.state.data2.units.map(record =>
                                                                    <option value={record.id}>{record.name}</option>
                                                                )}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">مبلغ هر واحد(ریال)</label>
                                                        <div className="form-control-wrap">
                                                            <NumberFormat className="form-control" type="text" thousandSeparator={true} defaultValue={this.state.data2.record.price} onChange={e => this.state.data2.record.price = e.target.value.replace(/,/g, '')} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">نرخ ارزش افزوده</label>
                                                        <div className="form-control-wrap">
                                                            <input maxLength="2" className="form-control" type="text" defaultValue={this.state.data2.record.taxRate} onChange={e => this.state.data2.record.taxRate = e.target.value} />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">درصد محاسبه تخفیف</label>
                                                        <div className="form-control-wrap">
                                                            <input maxLength="2" className="form-control" type="text" defaultValue={this.state.data2.record.discountPercent} onChange={e => this.state.data2.record.discountPercent = e.target.value} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.state.data2.record.status === true &&
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">درصد محاسبه اجرت</label>
                                                            <div className="form-control-wrap">
                                                                <input maxLength="2" className="form-control" type="text" defaultValue={this.state.data2.record.wage} onChange={e => this.state.data2.record.wage = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">درصد محاسبه حق العمل</label>
                                                            <div className="form-control-wrap">
                                                                <input maxLength="2" className="form-control" type="text" defaultValue={this.state.data2.record.rightOfAction} onChange={e => this.state.data2.record.rightOfAction = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <label className="form-label">درصد محاسبه سود</label>
                                                            <div className="form-control-wrap">
                                                                <input maxLength="2" className="form-control" type="text" defaultValue={this.state.data2.record.profit} onChange={e => this.state.data2.record.profit = e.target.value} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>


                                            }

                                            <br />
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <button type="submit" className="btn btn-lg btn-primary">ثبت</button>
                                                    <a className="hand btn btn-lg btn-warning" style={{ "marginRight": '10px' }} onClick={e => this.inquery()}>استعلام</a>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg" >
                <ModalHeader
                    toggle={this.toggle}
                    close={
                        <Button className="close" onClick={this.toggle}>
                            بستن
                        </Button>
                    }
                >
                    <h3>{this.state.lableholder}</h3>
                </ModalHeader>
                <ModalBody>
                    <div className="nk-block nk-block-lg">
                        <div className="card card-bordered">
                            <div className="card-inner">
                                <div className="card-head">

                                </div>
                                <div className="card-body">
                                    <div className="card-inner position-relative card-tools-toggle">
                                        <div className="card-title-group">
                                            <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                                <div className="form-inline flex-nowrap gx-3">
                                                    <div className="form-wrap">
                                                        <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="عنوان یا کد مالیاتی کالا" className="form-control" />
                                                    </div>
                                                    <div className="btn-wrap">
                                                        <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="card-inner p-0">
                                        <div className="nk-tb-list nk-tb-ulist">
                                            <div className="nk-tb-item nk-tb-head" style={{ backgroundColor: "#16498a" }}>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">ردیف</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">کد</span></div>
                                                <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center text-white">مشمول</span></div>
                                                <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center text-white">درصد مالیات</span></div>
                                                <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center text-white">عنوان</span></div>
                                                <div className="nk-tb-col tb-col-md"><span className="sub-text text-center text-white">نوع</span></div>
                                                <div className="nk-tb-col text-end"><span className="sub-text text-white">عملیات</span></div>
                                            </div>
                                            {this.state.data.records.map((record, index) =>
                                                <div className="nk-tb-item">
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{this.genRowNumber(index)}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.id}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.taxableOrFree}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.vat}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.descriptionOfID}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{record.typeTitle}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                        <a onClick={e => this.setkala(record.id, record.descriptionOfID, record.vat) } class="btn btn-dim btn-success">انتخاب کالا</a>
                                                    </div>
                                                    
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {this.createPaging()}
                                </div>

                            </div>
                        </div>
                    </div>
                </ModalBody>

            </Modal >


        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data2} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}